module.exports = __webpack_public_path__ + "static/two-man-640a9fe2c2a7e52b031abda9f30c6a6d.png";